import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getDemandGroupDirectory } from '@ebalance/proto/bffuser/v1/demand_group_service-DemandGroupService_connectquery'
import {
  GetDemandGroupDirectoryRequestSchema,
  type GetDemandGroupDirectoryResponse,
} from '@ebalance/proto/bffuser/v1/demand_group_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 需要グループ画面の目録 (組織の全グループ)。エリアでの絞り込みは表示側の仕事で、
 * 再取得しない (`entriesInArea`)。
 *
 * 取得失敗は一覧の代わりに画面内のエラーで出す (spec AC-CDG-034)。error boundary
 * (全画面エラー) に飛ばさないよう、global QueryClient の `throwOnError: true` を本 query
 * だけ `false` に上書きする (docs/guides/frontend-coding-guide.yaml「queries は
 * throwOnError: true」からの意図的な逸脱。先例: useListDemandConfirmRecords)。
 */
export function useDemandGroupDirectory(): UseQueryResult<
  GetDemandGroupDirectoryResponse,
  ConnectError
> {
  return useQuery(
    getDemandGroupDirectory,
    create(GetDemandGroupDirectoryRequestSchema, {}),
    { throwOnError: false },
  )
}
